// extracted by mini-css-extract-plugin
export default {"button":"button_button__gxFeB","button__rightIcon":"button_button__rightIcon__d5Wcc"};